/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        margin: `${theme.spacing(3)}px 0px`,
        borderBottomStyle: 'dotted',
        borderWidth: 1,
        [theme.breakpoints.down('sm')]: {
            margin: '8px 0px',
        },
    },
}));

export default function ListDividers() {
    const classes = useStyles();

    return (
        <Divider className={classes.root} />
    );
}
